<template>
  <div class="ti-confirmation">
    <EmailConfirmationComponent
      v-if="step.stepId === 'emailconfirmation'"
      :valuation="step.data.residualValue"
    />

    <DealerConfirmationComponent
      v-if="
        step.stepId === 'dealerconfirmation' ||
        step.stepId === 'emaildealerconfirmation'
      "
      :valuation="step.data.residualValue"
      :dealer="step.data.dealerInfo"
      :isOneJourney="step.data.oneJourney === true"
    />
    <NavigationComponent
      class="ti-confirmation__navigation"
      v-if="
        (step.stepId === StepIds.emailconfirmation &&
          step.data.residualValue) ||
        step.next ||
        step.stepId === 'ratelimit'
      "
      :step="step"
      :history="history"
      :key="step.stepId"
      :completed="true"
      @nextClicked="nextClicked"
      @prevClicked="prevClicked"
    />
  </div>
</template>
<script lang="ts" setup>
import { onMounted } from 'vue';
import { Step } from '@tradein/api';
import { StepIds } from '@tradein/store';

import DealerConfirmationComponent from '../../components/dealer-confirmation/dealer-confirmation.vue';
import EmailConfirmationComponent from '../../components/email-confirmation/email-confirmation.vue';
import NavigationComponent from '../../components/navigation/navigation.vue';

import setup from '../../composables/setup';
import { trackingService } from '../../utils/tracking';

interface Props {
  history: Step[];
  step: Step;
  loading: boolean;
}

const { configurationId, applicationInfos, originatingApp, $parseSrc } =
  setup();
const props = defineProps<Props>();
const emit = defineEmits(['navigateToStep', 'nextClicked', 'prevClicked']);

const nextClicked = (): void => {
  emit('nextClicked');
};

const prevClicked = (): void => {
  emit('prevClicked');
};
</script>
<style lang="scss" src="./confirmation.scss"></style>
